import React, { useEffect } from "react";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import TrackingBar from "./Order/TrackingBar";
import { Outlet, useLocation } from "react-router-dom";
import Loader from "./Loader/Loader";
import { useSelector } from "react-redux";
import { useScrollToTop, cleanupModalBackdrops } from "../helper/useScrollToTop";

function Layout() {
  const laoder = useSelector((state) => state.loader.loading);
  const location = useLocation();
  
  // This hook will automatically scroll to top on every route change
  useScrollToTop();

  // Clean up modal backdrops on route changes
  useEffect(() => {
    cleanupModalBackdrops();
  }, [location.pathname]);

  return (
    <>
      {laoder && <Loader />}
      <Header />
      <Outlet />
      <Footer />
      {/* 
        TrackingBar is conditionally displayed:
        - Only shows when there's a latest order with pending status
        - Hides when order is delivered, canceled, or rejected
        - Hides when there are no orders
        - Updates in real-time when order status changes
      */}
      <TrackingBar />
    </>
  );
}

export default Layout;
